import Vue from 'vue';
import store from 'store';
import { mapState } from 'vuex';
import * as queries from 'lib/graphql/queries';
import storefront from 'lib/storefront';
import { convertGQLToProductJson } from 'utils/general';

export default (el) =>
  new Vue({
    el,
    store,
    name: 'Product Compare',
    components: {
      'product-compare-heading': () => import('./product-compare-heading.vue'),
      'product-compare-row': () => import('./product-compare-row.vue'),
    },
    data: () => ({
      products: [],
      productFetchComplete: false,
    }),
    async beforeMount() {
      const productHandles = this.$el.dataset.productHandles.split('|');
      for (const handle of productHandles) {
        const { product } = await storefront.request(queries.product, {
          handle,
        });
        const formatted = convertGQLToProductJson(product);
        const productObject = {
          ...formatted,
          url: this.buildProductUrl(formatted),
        };
        this.products = [...this.products, productObject];
      }
      this.productFetchComplete = true;
    },
    computed: {
      ...mapState('global'),
    },
    methods: {
      buildProductUrl(product) {
        return `${Shopify.routes.root}products/${product.handle}`;
      },
    },
  });
